import { ArrowLeftOutlined } from "@ant-design/icons";
import UserIntro from "../ProfileSetup/UserIntro";
import SocialIcons from "../SourceConnector/OldSourceConnectorScreen";
import { Fragment, useState, useEffect } from "react";
import { Button, Col, Row } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const steps = [
  {
    id: 1,
    heading: "Hello! Welcome to DataTram",
    name: "Basic Information",
    component: UserIntro,
    // Nested route path (relative to /welcome-to-datatram)
    path: "basic-information",
  },
  {
    id: 2,
    heading: "Almost there. Connect to as many data sources as possible.",
    name: "Connect Data Sources",
    component: SocialIcons,
    // Nested route path
    path: "connect-sources",
  },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [, setCompletedSteps] = useState(Array(steps.length).fill(false));
  const [showMagicScreen, setShowMagicScreen] = useState(false);
  const [connectedConnectors, setConnectedConnectors] = useState<string[]>([]);

  const location = useLocation();

  useEffect(() => {
    // Retrieve the currentStep from localStorage if available
    const storedStep = localStorage.getItem("currentStep");
    if (storedStep !== null) {
      setCurrentStep(parseInt(storedStep, 10));
    }
  }, []);

  // useEffect(() => {
  //   // Save the currentStep to localStorage whenever it changes
  //   localStorage.setItem("currentStep", currentStep.toString());
  // }, [currentStep]);

  useEffect(() => {
    const state = location.state;
    if (state && state.currentStep !== undefined) {
      setCurrentStep(state.currentStep); // Set the currentStep to 1 (for SourceConnector)
    }
  }, [location]);

  const nextStep = (isValid: boolean) => {
    if (currentStep < steps.length && isValid) {
      // Move to the next step if valid
      setCompletedSteps((prev) => {
        const updatedSteps = [...prev];
        updatedSteps[currentStep] = true;
        return updatedSteps;
      });
      //setIsPaymentStep(false); // Reset payment step flag
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleDoneClick = () => {
    setShowMagicScreen(true);
  };

  if (showMagicScreen) {
    navigate("/welcome-to-datatram/data-loading");
  }

  const CurrentComponent = steps[currentStep]?.component;

  const handleConnectionCreated = (connectorName: string) => {
    setConnectedConnectors((prev) => {
      const updatedConnectors = [...prev, connectorName]; // Add new connector
      return updatedConnectors;
    });
  };

  // **Determine if Current Step is SourceConnector (step 3)**
  const isSourceConnectorStep = steps[currentStep].id === 2;

  useEffect(() => {
    if (isSourceConnectorStep) {
      navigate("/welcome-to-datatram/connect-sources" , { state: { from: "basic-information" } });
    }
  }, [isSourceConnectorStep, navigate]);

  return (
    <Fragment>
      <Row gutter={[16, 16]}>
        <Col xs={8} sm={6} md={6} lg={4} xl={4} xxl={4} className="stepbody" style={{backgroundImage:("url('/images/stepbg.png')")}}>
          <div className="sidebar-heading-container">
            <p className="stepheading">
              {/* {isPaymentStep
                ? "Confirm Your Payment"
                : steps[currentStep].heading} */}
              {steps[currentStep]?.heading}
            </p>
          </div>
          <div className="steps-list-section">
            <ul>
              {steps.map((step, index) => (
                <li key={index} className="step-item">
                  <div className="step-icon">
                    {index <
                    currentStep /*|| (index === 1 && isPaymentStep) */ ? (
                      <img
                        src="/images/tick.svg"
                        alt="Completed"
                        className="tick-icon"
                      />
                    ) : (
                      <div className="steps-circle">{index + 1}</div>
                    )}
                  </div>
                  <span className="step-name">{step.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <div
            style={{
              marginTop: "100px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {currentStep > 0 && (
              <Button className="prebutton" onClick={prevStep}>
                <span className="button-icon">
                  <ArrowLeftOutlined />
                </span>
              </Button>
            )}

            <Button
              className="nextbutton"
              onClick={() => {
                if (steps[currentStep].id === 1) {
                  (document.getElementById("nextBtn") as HTMLElement).click();
                } else if (steps[currentStep].id === steps.length) {
                  handleDoneClick();
                } else {
                  nextStep(true);
                }
              }}
              disabled={
                // (steps[currentStep].id === 2 &&
                //   !payNowClicked &&
                //   !isPaymentStep) ||
                steps[currentStep].id === 2 && connectedConnectors.length === 0 // **Updated Condition**
              }
            >
              {currentStep === steps.length - 1 ? "Done" : "Next"}
            </Button>
          </div>
        </Col>

        <Col xs={16} sm={18} md={18} lg={18} xl={18} xxl={18}>
          {isSourceConnectorStep ? (
            <SocialIcons
              onNext={(isValid: boolean) => nextStep(isValid)}
              onBack={
                steps[currentStep].component === UserIntro
                  ? prevStep
                  : () => {
                      /*nothing*/
                    }
              }
              // payNowClicked={confirmPayment}
              onConnectionCreated={handleConnectionCreated} // **Only for SocialIcons**
              // {...(CurrentComponent === PaymentConfirmation
              //   ? { handlePaymentConfirmation }
              //   : {})}
            />
          ) : (
            <CurrentComponent
              onNext={(isValid: boolean) => nextStep(isValid)}
              onBack={() => {
                if (currentStep > 0) {
                  navigate(
                    `/welcome-to-datatram/${steps[currentStep - 1].path}`
                  );
                }
              }}
            />
          )}
        </Col>
      </Row>
      <Outlet />
    </Fragment>
  );
}
